import { ArrowRight, Briefcase } from "lucide-react";

function WorkingHoursMockup() {
  // Day strip: weekdays light up, weekends visibly dim. The weekend cells
  // are the "blocked" surface that the toggle creates.
  const days = [
    { label: "M", active: true },
    { label: "T", active: true },
    { label: "W", active: true, today: true },
    { label: "T", active: true },
    { label: "F", active: true, overdue: true },
    { label: "S", active: false },
    { label: "S", active: false },
  ];

  return (
    <div className="bg-warm-bg-card border border-warm-border rounded-2xl shadow-soft-lg p-6 space-y-5">
      {/* Toggle card — ON state, mirrors the real TaskDialog styling */}
      <div className="bg-warm-bg-base border border-warm-border rounded-lg p-3 space-y-3">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded border border-warm-border shrink-0" />
          <span className="text-sm font-medium text-warm-text-primary">
            💼 Send quarterly report
          </span>
        </div>
        {/* Toggle row */}
        <div className="flex items-center gap-3 px-3 py-2.5 rounded-soft bg-warm-blue/10 border border-warm-blue/30">
          <Briefcase className="w-4 h-4 text-warm-blue shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="text-xs font-medium text-warm-blue">
              Working hours only
            </div>
            <div className="text-[10px] text-warm-text-tertiary leading-tight mt-0.5">
              Mon–Fri, 9 AM – 5 PM
            </div>
          </div>
          <div className="relative w-8 h-4 rounded-full bg-warm-blue shrink-0">
            <div className="absolute top-0.5 right-0.5 w-3 h-3 bg-white rounded-full shadow-sm" />
          </div>
        </div>
      </div>

      {/* Day strip — weekdays active, weekends dim */}
      <div>
        <div className="text-[9px] uppercase tracking-wider text-warm-text-tertiary font-medium mb-2 px-0.5">
          This week
        </div>
        <div className="grid grid-cols-7 gap-1.5">
          {days.map((d, i) => (
            <div
              key={i}
              className={`rounded-md text-center py-2.5 transition-colors ${
                !d.active
                  ? "bg-warm-bg-elevated/50 text-warm-text-tertiary/40 line-through decoration-warm-text-tertiary/40"
                  : d.today
                    ? "bg-warm-blue/10 border border-warm-blue/40 text-warm-blue font-medium"
                    : "bg-warm-bg-elevated border border-warm-border-subtle text-warm-text-secondary"
              }`}
            >
              <div className="text-[10px] font-medium">{d.label}</div>
              {d.active && (
                <div
                  className={`w-1 h-1 rounded-full mx-auto mt-1 ${
                    d.today
                      ? "bg-warm-blue animate-pulse"
                      : d.overdue
                        ? "bg-red-400 dark:bg-red-500"
                        : "bg-warm-text-tertiary/40"
                  }`}
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Friday → Monday rollover (skipping the weekend) */}
      <div className="flex items-stretch gap-3">
        {/* Friday */}
        <div className="flex-1 bg-warm-bg-elevated rounded-lg p-3 border border-warm-border-subtle">
          <div className="text-[9px] uppercase tracking-wider text-warm-text-tertiary font-medium mb-2">
            Friday
          </div>
          <div className="bg-warm-bg-base border border-warm-border-subtle rounded px-2 py-1.5 flex items-center gap-1.5">
            <div className="w-3 h-3 rounded border border-warm-border shrink-0" />
            <span className="text-[11px] text-warm-text-tertiary line-through">
              💼 Send quarterly report
            </span>
          </div>
          <div className="text-[9px] text-red-500 dark:text-red-400 mt-1.5 ml-0.5">
            Not completed
          </div>
        </div>

        {/* Arrow — skips over the weekend (notice the label) */}
        <div className="flex flex-col items-center justify-center px-1">
          <div className="text-[8px] uppercase tracking-wider text-warm-text-tertiary/70 font-medium mb-1">
            Skip
          </div>
          <ArrowRight className="w-4 h-4 text-warm-blue animate-bounce-x" />
          <div className="text-[8px] uppercase tracking-wider text-warm-text-tertiary/70 font-medium mt-1">
            Sat · Sun
          </div>
        </div>

        {/* Monday */}
        <div className="flex-1 bg-warm-bg-elevated rounded-lg p-3 border border-warm-blue/30">
          <div className="text-[9px] uppercase tracking-wider text-warm-blue font-medium mb-2">
            Monday
          </div>
          <div className="bg-warm-bg-base border border-warm-blue/30 rounded px-2 py-1.5 flex items-center gap-1.5">
            <div className="w-3 h-3 rounded border border-warm-border shrink-0" />
            <span className="text-[11px] text-warm-text-primary font-medium">
              💼 Send quarterly report
            </span>
          </div>
          <div className="text-[9px] text-warm-blue mt-1.5 ml-0.5">
            Rescheduled
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkingHoursMockup;
